const toOption = (value, label) => ({ value, label });

export const PRACTICE_TYPE_OPTIONS = [
  toOption("General Physician", "General Physician"),
  toOption("Dentist", "Dentist"),
  toOption("Physio", "Physio"),
];

export const COUNTY_OPTIONS = [
  toOption("antrim", "Antrim"),
  toOption("armagh", "Armagh"),
  toOption("carlow", "Carlow"),
  toOption("cavan", "Cavan"),
  toOption("clare", "Clare"),
  toOption("cork", "Cork"),
  toOption("derry", "Derry"),
  toOption("donegal", "Donegal"),
  toOption("down", "Down"),
  toOption("dublin", "Dublin"),
  toOption("fermanagh", "Fermanagh"),
  toOption("galway", "Galway"),
  toOption("kerry", "Kerry"),
  toOption("kildare", "Kildare"),
  toOption("kilkenny", "Kilkenny"),
  toOption("laois", "Laois"),
  toOption("leitrim", "Leitrim"),
  toOption("limerick", "Limerick"),
  toOption("longford", "Longford"),
  toOption("louth", "Louth"),
  toOption("mayo", "Mayo"),
  toOption("meath", "Meath"),
  toOption("monaghan", "Monaghan"),
  toOption("offaly", "Offaly"),
  toOption("roscommon", "Roscommon"),
  toOption("sligo", "Sligo"),
  toOption("tipperary", "Tipperary"),
  toOption("tyrone", "Tyrone"),
  toOption("waterford", "Waterford"),
  toOption("westmeath", "Westmeath"),
  toOption("wexford", "Wexford"),
  toOption("wicklow", "Wicklow"),
];
